function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m393.3 316.1-1.3.5c-5.1 2-19.9 3.5-29.4 3.5-8.9 0-20.7-3.3-27.6-12.5-2.6-3.6-5.2-9.1-5.2-17h-9l-6.9 27.6h-23.4l8.2-27.6h-7.4l-17.8 27.6h-18.8l-1.7-27.6h-8.3l-8.2 27.6h-20l8.5-27.6h-47v-.4l-8.4 28.1h-21.3l8.3-27.7h-26l12.9 27.7h-24.6l-11.2-27.7H101c-4.2 13.6-7.5 24.6-7.7 25.4l-.4 2.2H70l21-69.8v-68.7h78.6v67.9l3-10h5.4v-57.9h78.4v57.9h8.4v-57.9h78.4V253c2.6-3.6 5.5-6.5 8.4-8.7v-64.4H430v110.8h-29.6l-7.1 25.4zm-41.6-25.5c0 3.6.7 6.6 2.3 8.6 2.2 3 6.2 4.5 11.8 4.5 6.2 0 8.6-.7 9.4-1l3.9-12.1h-27.4",
    style: {
      fill: "#00519a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9 263.1c-2.5 7.6-6 11.5-17.3 11.8h-13.4l6.9-23.6c16.9 0 28.2-1.4 23.8 11.8zm-96.7-22.6h-17l-22.5 74.9h16.8c.4-1.5 22.7-74.9 22.7-74.9zm44.1 0h-20.6l-32.8 33.1 16.9 41.8h18.3l-18.9-40.3 37.1-34.6zm68.1 22.6c4.3-23.1-14.3-22.8-31.6-22.6h-19.1l-22.7 75h15.4l8.8-29.6h12.3c24.1 0 34.7-10.7 36.9-22.8zm105-22.6h-24.6c-29.9 41.5-37.2 64.8-37.2 64.8 2.9-26.4-.9-64.8-.9-64.8h-24.4l-22.9 74.9h14.1l19-64.1 3.9 64.1H272l41.4-64.1-19 64.1h17.3l18.7-74.9zm48.8-1.6c-15.1 0-33.8 3.4-44.5 38.8-9 29.6 12.8 39.7 28 39.7 10 0 24.1-1.7 28.3-3.4l10.6-37.8h-31.8l-3.5 11.3H383l-5.2 16.4s.7 2.6-11.9 2.6c-15.9 0-20.3-11-15.1-29.2 4.8-16.9 12.6-28.2 26.9-27.5 9.7.4 15.2 4.1 12.5 13-.1.6-.2 1.4-.5 1.9h15.4c3.9-11.5-3.9-25.8-25.9-25.8",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpmg);
export default __webpack_public_path__ + "static/media/kpmg.b309e4bbc68d6b1060bba205c604926e.svg";
export { ForwardRef as ReactComponent };